import { Driver } from '@typeRoots/common/drivers';

export const handleInputChange = (
  field: keyof Driver,
  value: string,
  onChange: (field: keyof Driver, value: string) => void,
) => {
  // Replace multiple spaces with a single space
  let cleaned = value.replace(/\s{2,}/g, ' ');

  switch (field) {
    case 'firstName':
    case 'lastName':
      // Allow empty string OR a name that starts with a letter and contains only allowed characters
      if (cleaned === '' || (/^[A-Za-z][A-Za-z\s'-]*$/.test(cleaned) && cleaned.length <= 50)) {
        onChange(field, cleaned);
      }
      break;

    case 'yearsOfExperience':
      // Allow empty string and valid positive integers between 0 and 50 years
      if (
        cleaned === '' ||
        (/^[0-9]{1,2}$/.test(cleaned) && parseInt(cleaned, 10) <= 50 && !/^0\d+$/.test(cleaned))
      ) {
        onChange(field, cleaned); // Update state if valid or empty
      }
      break;

    case 'monthsOfExperience':
      // Allow empty string and valid positive integers between 0 and 11 months
      if (
        cleaned === '' ||
        (/^[0-9]{1,2}$/.test(cleaned) && parseInt(cleaned, 10) <= 11 && !/^0\d+$/.test(cleaned))
      ) {
        onChange(field, cleaned); // Update state if valid or empty
      }
      break;

    case 'accidents':
    case 'violations':
    case 'suspensions':
    case 'majorViolations':
      // Allow empty string or only non-negative integers, including 0
      if (cleaned === '' || (/^[0-9]+$/.test(cleaned) && parseInt(cleaned, 10) >= 0)) {
        onChange(field, cleaned); // Update state if valid or empty
      }
      break;

    default:
      onChange(field, cleaned); // Update state if no specific validation is needed
  }
};

// Validates the DL extractor response to ensure it contains valid data.
export const isValidDriverResponse = (data: Partial<Driver>): boolean => {
  // List of fields that should not be null for a valid response
  const requiredFields: (keyof Driver)[] = [
    'firstName',
    'lastName',
    'dlNumber',
    'dlState',
    'dateOfBirth',
  ];

  // Check if any required field is null, undefined, or an empty string
  return requiredFields.every(
    (field) => data[field] !== null && data[field] !== undefined && data[field] !== '',
  );
};
